import { useState, useEffect } from 'react';

/** Largeur max (px) pour considérer la vue comme mobile — aligné sur Tailwind `md` */
export const MOBILE_BREAKPOINT = 768;

function getInitialWidth() {
  if (typeof window === 'undefined') return MOBILE_BREAKPOINT + 1;
  return window.innerWidth;
}

function getInitialHeight() {
  if (typeof window === 'undefined') return 600;
  return window.innerHeight;
}

/**
 * Taille de la fenêtre et indicateur mobile (< MOBILE_BREAKPOINT).
 */
export default function useWindowSize() {
  const [width, setWidth] = useState(getInitialWidth);
  const [height, setHeight] = useState(getInitialHeight);

  useEffect(() => {
    const onResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {
    width,
    height,
    isMobile: width < MOBILE_BREAKPOINT,
  };
}
